import React from "react";
import Layout from "./components/Layout";

/** the app just returns the layout */
const App = () => {
    return <Layout />
}
export default App